import { render, staticRenderFns } from "./FeedItemCall.vue?vue&type=template&id=59bec711&scoped=true&"
import script from "./FeedItemCall.vue?vue&type=script&lang=js&"
export * from "./FeedItemCall.vue?vue&type=script&lang=js&"
import style0 from "./FeedItemCall.vue?vue&type=style&index=0&id=59bec711&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bec711",
  null
  
)

export default component.exports